import { Button } from '../ui/button';
import { Link } from '../ui/link';

import classes from '@/styles/blog.module.css';
import clsx from 'clsx';
import { FORMAT_DATE1, formatDate } from '@/utility/date';

function truncate(str: string, n: number) {
  return str?.length > n ? `${str.substr(0, n - 1)  }...` : str;
}

export default function BlogCard({ blog }) {
  const { title, slug, excerpt, feature_image, reading_time, published_at } =
    blog;

  return (
    // <Link href={`/blog/${slug}`} title={title}>
    //   <div
    //     className="shadow-xl flex flex-col justify-between space-y-4 h-80  opacity-55 p-4 text-white relative rounded-md hover:scale-105 transform duration-200"
    //     style={{
    //       backgroundImage: `url(${feature_image})`,
    //       backgroundPosition: "center",
    //       backgroundSize: "auto",
    //       backgroundRepeat: "no-repeat",
    //     }}
    //   >
    //     <div className="bg-black absolute inset-0 z-10 bg-opacity-40 bg-gradient-to-b from-green-500 rounded-md" />
    //     <div className="flex flex-col justify-between h-full z-20">
    //       <div className="text-md md:text-2xl font-bold">{title}</div>
    //       <div className="flex flex-row space-x-4 bg-white bg-opacity-100 px-4 py-2 rounded-md items-center">
    //         <div className="text-sm md:text-base font-bold italic text-primary-500">
    //           {primary_author.name}
    //         </div>
    //         <div className="text-sm md:text-base text-gray-700">
    //           {formatDate(created_at, "LL")}
    //         </div>
    //       </div>
    //     </div>
    //   </div>
    // </Link>
    <Link href={`/blog/${slug}`} title={title} prefetch={false}>
      <div
        className={clsx(
          'hover:shadow-lg flex flex-col space-y-4 opacity-55 relative rounded-sm transform duration-500 bg-white border border-gray-50 group overflow-hidden',
          classes['blog-root']
        )}
      >
        <div
          className={clsx(
            'relative h-60 w-full border-none',
            classes['blog-card']
          )}
        >
          <img
            src={feature_image}
            // layout="fill"
            alt={title}
            // objectFit="cover"
            className="rounded-t-sm"
            style={{ objectFit: 'cover', backgroundColor: 'white' }}
          />
        </div>
        <div className="flex flex-col h-full z-20 px-8 pb-8 pt-4">
          <span className="text-xs text-gray-500 font-semibold">
            {formatDate(published_at, FORMAT_DATE1)}
          </span>
          <div className="text-md md:text-2xl font-extrabold text-black my-2">
            {title}
          </div>
          <div className="w-8 h-1 bg-green-400 mb-4" />

          <span className="text-gray-500">{truncate(excerpt, 100)}</span>
          <span className="text-gray-400 text-sm font-medium my-1">
            {reading_time} min read
          </span>
          <div className="mt-4">
            <Button className="rounded-lg h-10">Read More</Button>
          </div>
        </div>
      </div>
    </Link>
  );
}
